import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { TableTimeslotsComponent } from '../../components/table-timeslots/table-timeslots.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { CardServiceComponent } from '../../components/card-service/card-service.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import ConciergeService from '../../services/concierge.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { PanelDirective } from '../../directives/panel.directive';
import { MatSelectModule } from '@angular/material/select';
import { Subscription } from 'rxjs';
import DialogServices from '../../services/dialog.service';
import { ModalBookingEnquiryComponent } from '../../components/modal-booking-enquiry/modal-booking-enquiry.component';

@Component({
	standalone: true,
	selector: 'booking-service',
	templateUrl: './booking-service.component.html',
	imports: [
		CommonModule, MatSelectModule, PanelDirective, TranslatePipe,
		ItemInfoPopoverComponent, TableTimeslotsComponent, LoaderOverlayComponent,
		ItemErrorComponent, CardServiceComponent, ItemNotificationComponent, FormsModule
	]
})
export default class BookingServiceView implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private conciergeService: ConciergeService = inject(ConciergeService);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private dialogServices: DialogServices = inject(DialogServices);

	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.initialized = false;
		this.vm.isLoading = false;
		this.vm.loadingTimeslots = true;
		this.vm.booking = {};
		this.vm.booking.callType = 'VIDEO';
        this.vm.selectedAppointmentMode = this.vm.booking?.communicationType || 'VIDEO';
        this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
		this.vm.booking.platform = 'BROWSER';
		this.vm.booking.origin = this.session.getSession().user.origin;
		this.vm.booking.careTakenInfo = {};
		this.vm.descMaxLength = 300;
		this.vm.user = this.session.getSession().user;
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.skipRedirectCheck = this.angularRoutingHelperService.getQueryParams()['skipRedirectCheck'];
		this.vm.isAddressRequired = true;
		this.vm.popoverMobileWrapper = document.querySelector('.c-section--last > .c-section__content');
		this.vm.isOpen = {
			service: true
		};

		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
		this.vm.initialized = true;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	onResolve() {
		this.getService().then(() => {
			this.getTimeslots();
		});
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Modal.EMPLOYER_INVITE_CONFIRMATION_CLOSING,
				() => { this.executeUserRedirectionChecks(); })
		);

		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.getPlatformProblemPlaceholderTranslation = this.getPlatformProblemPlaceholderTranslation;
	}
	
	onTimeslotChange(newTimeslot: any) {
		this.vm.selectedDate = this.vm.timeslots.filter((item) => {
			return item.date === moment(this.vm.selectedTimeslot.startTime).format('D.MM');
		})[0];
	}

	getAppointments() {
		var deferred: any = this.angularHelperService.getDeferredPromise();

		this.serviceRestServices.activeBookings({ forBusiness: false }, (appointments) => {
			appointments = appointments || [];
			appointments.map((item) => {
				item.date = moment(item.scheduledStart).format('D MMMM YYYY');
				item.startTime = moment(item.scheduledStart).format('k:mm');
				item.endTime = moment(item.scheduledEnd).format('k:mm');
			});
			deferred.resolve(appointments);
		});

		return deferred.promise;
	}

	getPlatformProblemPlaceholderTranslation() {
		if (this.vm.user?.origin == 'siffi.com') {
			return this.angularFilterHelperService.translate('Booking.Problem_Description_Siffi_Placeholder');
		} else {
			return this.angularFilterHelperService.translate('Booking.Problem_Description_Placeholder');
		}
	}

	executeUserRedirectionChecks() {
		this.vm.isLoading = true;
		if (this.vm.skipRedirectCheck) {
			this.vm.isLoading = false;
			return;
		}

		this.conciergeService.getBookingPreliminaryCheck(this.vm.serviceId).then((result) => {
			if (result.redirectRequired) {
				var queryParams = {
					step: 'CONSULTANT',
					serviceId: this.vm.serviceId
				};
				this.angularRoutingHelperService.setPath('/booking/mental-check', false, false, queryParams);
			} else {
				//Redirect directly to booking
				this.vm.isLoading = false;
			}
		});
	}

	getService() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var serviceId: any = this.vm.serviceId || this.angularRoutingHelperService.getRouteParam('serviceId');
		this.serviceRestServices.getServiceById({ id: serviceId }, (service) => {
			this.angularHelperService.forEach(service.fieldTranslations, (field) => {
				if (field.language === this.vm.user.deviceLanguage.slice(0, 2) && field.furtherSubcategory === service.furtherSubcategory) {
					service.translation = field.translation;
				}
			});
			this.vm.isAddressRequired = service.customerContactAddressRequired;
			this.vm.service = service || {};

			if (this.vm.service.typeOfAppointment === 'FACE_TO_FACE_SESSION_ONLY') {
				this.vm.selectedAppointmentMode = 'FACE_TO_FACE';
				this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
			} else if (this.vm.service.typeOfAppointment === 'VIDEO_SESSION_ONLY') {
				this.vm.selectedAppointmentMode = 'VIDEO';
				this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
			} else if (this.vm.service.typeOfAppointment === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
				this.vm.selectedAppointmentMode = 'VIDEO';
				this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
			}

			this.executeUserRedirectionChecks();
			deferred.resolve();
		});
		return deferred.promise;
	}

	getSlots(schedule, timeslotsCount, timeslot) {
	    const slots = [];
	    const bufferMinutes = this.vm.service.subcategory === 'HOME_VISITS' ? 60 : 30;
	    const nowPlusBuffer = new Date(Date.now() + bufferMinutes * 60000);
	    const slotDurationMs = schedule.pricing.timePerPrice * 60000; // timePerPrice in ms

	    const bookings = schedule.bookings || [];
	    const appointments = schedule.appointments || [];
	    const excludedDateTimes = schedule.excludedDateTimes || [];

	    for (let j = 0; j < timeslotsCount; j++) {
	        const startTime = new Date(new Date(timeslot.startTime).getTime() + slotDurationMs * j);
	        const endTime = new Date(startTime.getTime() + slotDurationMs);
	        let pushable = true;

	        if (startTime < nowPlusBuffer) {
	            pushable = false;
	        }

	        // Check overlaps with bookings
	        if (pushable && bookings.length) {
	            for (const booking of bookings) {
	                if (!(booking.status === 'BOOKED' && booking.user && booking.user.id === this.vm.user.id) &&
	                    this.isOverlapping(startTime, endTime, new Date(booking.scheduledStart), new Date(booking.scheduledEnd))) {
	                    pushable = false;
	                    break;
	                }
	            }
	        }

	        // Check overlaps with excludedDateTimes
	        if (pushable && excludedDateTimes.length) {
	            for (const excluded of excludedDateTimes) {
	                if (this.isOverlapping(startTime, endTime, new Date(excluded.startDateTime), new Date(excluded.endDateTime))) {
	                    pushable = false;
	                    break;
	                }
	            }
	        }

	        // Check overlaps with user appointments
	        if (pushable && appointments.length) {
	            for (const appointment of appointments) {
	                if (this.isOverlapping(startTime, endTime, new Date(appointment.scheduledStart), new Date(appointment.scheduledEnd))) {
	                    pushable = false;
	                    break;
	                }
	            }
	        }

	        if (pushable) {
	            slots.push({
	                startTime,
	                endTime,
	                start: this.formatTime(startTime),
	                end: this.formatTime(endTime),
	                slotID: timeslot.id
	            });
	        }
	    }

	    return slots;
	}

	isOverlapping(start1, end1, start2, end2) {
	    // Return true if any overlap
	    return start1 < end2 && end1 > start2;
	}

	formatTime(date) {
	    return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
	}

	getTimeslots() {
        this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
		this.vm.selectedTimeslot = null;
	    this.vm.loadingTimeslots = true;
	    this.getAppointments().then((appointments) => {
	        this.serviceRestServices.getAvailableBookingSchedule({
	            businessServiceId: this.vm.serviceId,
	            startDate: this.formatDate(new Date()), // YYYYMMDD
	            endDate: this.formatDate(new Date(Date.now() + 91 * 86400000)) // +91 days
	        }, (schedule) => {
                var timeslots = schedule.timeSlots || [];
                var bookings = schedule.bookings || [];
	            schedule.appointments = appointments || [];

                if (this.vm.service?.typeOfAppointment === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
                    if (this.vm.selectedAppointmentMode === 'VIDEO') {
                        timeslots = timeslots.filter(t => t.isVideoSupported);
                    } else if (this.vm.selectedAppointmentMode === 'FACE_TO_FACE') {
                        timeslots = timeslots.filter(t => t.isOnSiteSupported);
                    }
                }

	            // Set active booking if exists
	            if (timeslots.length || bookings.length) {
	                for (const booking of bookings) {
	                    if (!booking.user || booking.status !== 'BOOKED') continue;
	                    const start = new Date(booking.scheduledStart);
	                    const end = new Date(booking.scheduledEnd);
	                    this.vm.selectedTimeslot = {
	                        startTime: start,
	                        endTime: end,
	                        start: this.formatTime(start),
	                        end: this.formatTime(end),
	                        slotID: booking.timeSlot.id,
	                        bookingID: booking.id,
	                    };
	                    if (booking.careTakenInfo) {
	                        this.vm.isForCareTaken = true;
	                        this.vm.booking.careTakenInfo = booking.careTakenInfo;
	                    }
	                    this.vm.booking.id = booking.id;
	                    this.vm.booking.callType = 'VIDEO';
                        this.vm.booking.communicationType = this.vm.selectedAppointmentMode;
                        //this.vm.selectedAppointmentMode = booking.communicationType;
	                    this.vm.booking.comment = booking.comment;
	                    this.vm.booking.started = new Date(booking.bookingStart);
	                }
	            }
	            this.vm.isBookingInitialized = true;

	            // Sort timeslots by start time
	            timeslots.sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());

	            const weekdates = [];
	            for (const timeslot of timeslots) {
	                const startTime = new Date(timeslot.startTime);
	                const endTime = new Date(timeslot.endTime);
	                const durationMinutes = (endTime.getTime() - startTime.getTime()) / 60000;
	                const slotsCount = Math.floor(durationMinutes / schedule.pricing.timePerPrice);

	                const isExcluded = (schedule.excludeDates || []).some(d =>
	                    this.isSameDay(new Date(d.excludeDate), startTime)
	                );

	                if (!isExcluded) {
	                    weekdates.push({
							name: startTime.toLocaleDateString(this.vm.user.deviceLanguage.slice(0, 2), { weekday: 'long' }).replace(/^\w/, c => c.toUpperCase()),
	                        date: `${startTime.getDate().toString().padStart(2, '0')}.${(startTime.getMonth() + 1).toString().padStart(2, '0')}`,
	                        slots: this.getSlots(schedule, slotsCount, timeslot)
	                    });
	                }
	            }

	            // Remove days with no available slots
	            const filteredWeekdates = weekdates.filter(weekdate => weekdate.slots.length > 0);
	            this.vm.timeslots = this.mergeSameDates(filteredWeekdates);

	            this.setTimeAndCommentFromSession();
	            this.angularHelperService.createTimer(() => {
	                this.vm.loadingTimeslots = false;
	            }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	        });
	    });
	}

	openBookingEnquiry() {
		this.dialogServices.show({
			controller: ModalBookingEnquiryComponent,
			service: this.vm.service,
			communicationType: this.vm.selectedAppointmentMode
		});
	}

	formatDate(date) {
	    const y = date.getFullYear();
	    const m = (date.getMonth() + 1).toString().padStart(2, '0');
	    const d = date.getDate().toString().padStart(2, '0');
	    return `${y}${m}${d}`;
	}

	isSameDay(date1, date2) {
	    return date1.getFullYear() === date2.getFullYear() &&
	           date1.getMonth() === date2.getMonth() &&
	           date1.getDate() === date2.getDate();
	}

	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || !this.vm.selectedTimeslot 
          || !this.vm.selectedTimeslot.startTime || this.vm.isProcessing) {
			if (!this.vm.booking.comment) this.vm.isOpen.description = true;
			if (!this.vm.selectedTimeslot || !this.vm.selectedTimeslot.startTime) this.vm.isOpen.time = true;
			return;
		}

		if (!this.vm.isForCareTaken) {
			delete this.vm.booking.careTakenInfo;
		}

		this.vm.isProcessing = true;
		this.vm.booking.service = { id: this.vm.service.id };
		this.vm.booking.timeSlot = { id: this.vm.selectedTimeslot.slotID };
		this.vm.booking.scheduledStart = moment(this.vm.selectedTimeslot.startTime);
		this.vm.booking.scheduledEnd = moment(this.vm.selectedTimeslot.endTime);

		this.serviceRestServices.createBooking(this.vm.booking,
			(res) => {
				if (this.vm.isAddressRequired) {
					this.angularRoutingHelperService.setPath(['/booking/service/', this.vm.service.id, 'address']);
				} else {
					this.angularRoutingHelperService.setPath(['/booking/service/', this.vm.service.id, 'checkout']);
				}
			},
			(err) => {
				this.vm.isProcessing = false;
				var message: any = err.error && err.error[0] && err.error[0].message;
				switch (message) {
					case 'Overlapping':
						this.toast.showAsync(this.angularFilterHelperService.translate('Booking.Errors.Overlapping_Time'), null, 6000, 'error');
						break;
				}
			}
		);
	}

	mergeSameDates(weekdates) {
	    const dateMap = new Map();

	    for (const weekdate of weekdates) {
	        if (!dateMap.has(weekdate.date)) {
	            // Add new entry
	            dateMap.set(weekdate.date, {
	                ...weekdate,
	                slots: [...weekdate.slots] // clone slots
	            });
	        } else {
	            // Merge slots into existing entry
	            const existing = dateMap.get(weekdate.date);
	            const slotMap = new Map(existing.slots.map(slot => [slot.start, slot]));

	            for (const slot of weekdate.slots) {
	                if (!slotMap.has(slot.start)) {
	                    slotMap.set(slot.start, slot);
	                }
	            }

	            // Replace slots with merged unique slots
	            existing.slots = Array.from(slotMap.values());
	        }
	    }

	    return Array.from(dateMap.values());
	}

	setTimeAndCommentFromSession() {
	    const bookingStr = window.sessionStorage.getItem('booking');
	    if (!bookingStr) return;

	    const booking = JSON.parse(bookingStr);
	    if (booking.comment) {
	        this.vm.booking.comment = booking.comment;
	    }
	    window.sessionStorage.removeItem('booking');
	    if (!booking.start) return;

	    const start = new Date(booking.start);
		const selectedDate = (this.vm.timeslots || []).find(item => {
		    const day = String(start.getDate()).padStart(2, '0');
		    const month = String(start.getMonth() + 1).padStart(2, '0');
		    return item.date === `${day}.${month}`;
		});
	    if (!selectedDate || !selectedDate.slots) return;

	    const selectedSlot = selectedDate.slots.find(
	        (item) => new Date(item.startTime).getTime() === start.getTime()
	    );

	    if (selectedSlot) this.vm.selectedTimeslot = selectedSlot;
	}

}
